import React, { useContext, useState } from 'react';
import useQueries from '../../../database/useQueries';
import { useLocation, useNavigate } from 'react-router-dom';
import { DataContext, TemplateContext } from '../pagesMains/GravesManagers/Graves';
import { useSelector } from 'react-redux';
import ColumnOrderingGrid from '../../template/table';
import { format } from 'date-fns';
import { fixNullValues, mapFieldValues, onClickRow } from '../plagins/utility';
import { GlobalContext } from '../../../App';
import { useEffect } from 'react';
import { createFetchDataServer, getTableData } from '../../../database/fetchData';
import LoadingOverlay from '../pagesMains/LoadingOverlay';
import PaymentsManagementExample from '../../template/tableV2/PaymentsManagementExample';

// פונקציה לחשב רוחב קומפוננטה מותאם
const calculateDynamicWidth = () => {
  const screenWidth = window.innerWidth; // רוחב המסך
  let componentWidth;

  if (screenWidth >= 1200) {
    // מסך מחשב
    componentWidth = screenWidth * 0.8; // 80%
  } else if (screenWidth >= 768) {
    // מסך טאבלט
    componentWidth = screenWidth * 0.95; // 95%
  } else {
    // מסך פלאפון
    componentWidth = screenWidth; // 100%
  }

  return Math.round(componentWidth);
};

const PaymentsHome = () => {
  // קבלת ערכים מהסטור
  const optionsFields = useSelector((state) => state.dataOptionsFieldsHe.data);
  const columns = useSelector((state) => state.columnsTablePayments.data);

  const [rowsPerPage, setRowsPerPage] = useState(25); // מספר רשומות להצגה בעמוד
  const [currentPage, setCurrentPage] = useState(1); // עמוד נוכחי

  const onPageChange = (item) => {
    console.log(item);
  };

  const onRowsPerPageChange = (item) => {
    console.log(item);
  };

  const context = useContext(DataContext);
  const fetchDataServer = createFetchDataServer(context);

  // טעינת היוזים לפונקציות עזר
  const { getEntityByAttr } = useQueries();
  const [loading, setLoading] = useState(true); // מצב טעינה

  // ערכי הראוטר
  const navigate = useNavigate();
  const location = useLocation();

  const { searchText, setTotalWidthContainer } = useContext(TemplateContext);
  const { token, setBreadcrumbs, setTitle } = useContext(GlobalContext);

  useEffect(() => {
    const width = calculateDynamicWidth();
    setTotalWidthContainer(width);

    // עדכון רוחב הקומפוננטה אם גודל המסך משתנה
    const handleResize = () => {
      const newWidth = calculateDynamicWidth();
      setTotalWidthContainer(newWidth);
    };

    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, [location.pathname]);

  useEffect(() => {
    setBreadcrumbs([]);
    setTitle(`מחירים`);
  }, [location.pathname]);

  const formatPrice = (price) => {
    return new Intl.NumberFormat('he-IL', { style: 'currency', currency: 'ILS' }).format(price);
  };

  const mappedData = mapFieldValues(context?.contextPayments, optionsFields).map((payment) => {
    const cemeteryName = payment?.cemeteryId && parseInt(payment?.cemeteryId) !== -1 ? getEntityByAttr(context?.contextCemeteries, 'unicId', payment?.cemeteryId)?.cemeteryNameHe : 'הכל';
    const blockName = payment?.blockId && parseInt(payment?.blockId) !== -1 ? getEntityByAttr(context?.contextBlocks, 'unicId', payment?.blockId)?.blockNameHe : 'הכל';
    const plotName = payment?.plotId && parseInt(payment?.plotId) !== -1 ? getEntityByAttr(context?.contextPlots, 'unicId', payment?.plotId)?.plotNameHe : 'הכל';
    const lineName = payment?.lineId && parseInt(payment?.lineId) !== -1 ? getEntityByAttr(context?.contextRows, 'unicId', payment?.lineId)?.lineNameHe : 'הכל';

    const graveType = parseInt(payment?.graveType) === -1 ? 'הכל' : payment?.graveType;
    const plotType = parseInt(payment?.plotType) === -1 ? 'הכל' : payment?.plotType;
    const buyerStatus = parseInt(payment?.buyerStatus) === -1 ? 'הכל' : payment?.buyerStatus;
    const resident = parseInt(payment?.resident) === -1 ? 'הכל' : payment?.resident;
    const priceDefinition = parseInt(payment?.priceDefinition) === -1 ? 'הכל' : payment?.priceDefinition;

    const startPayment = payment.startPayment ? format(new Date(payment.startPayment), 'dd/MM/yyyy') : '00/00/0000';
    const createDate = payment.createDate ? format(new Date(payment.createDate), 'dd/MM/yyyy') : '00/00/0000';

    const price = payment.price ? formatPrice(payment.price) : formatPrice(0);
    return {
      ...payment,
      graveType,
      plotType,
      buyerStatus,
      cemeteryName,
      resident,
      priceDefinition,
      blockName,
      plotName,
      lineName,
      startPayment,
      createDate,
      price
    };
  });

  useEffect(() => {
    // async function loadTableData() {
    //   const localTempData = await getTableData('myDatabase', 'myStore');
    //   if (localTempData) {
    //     const dataCemeteries = localTempData.find((item) => item.name === 'dataCemeteries');
    //     const dataBlocks = localTempData.find((item) => item.name === 'dataBlocks');
    //     const dataPlots = localTempData.find((item) => item.name === 'dataPlots');
    //     const dataRows = localTempData.find((item) => item.name === 'dataRows');
    //     const dataPayments = localTempData.find((item) => item.name === 'dataPayments');
    //     if (dataCemeteries && dataBlocks && dataPlots && dataRows && dataPayments) {
    //       setLoading(false);
    //     }
    //   }
    fetchDataServer(['cemeteries', 'blocks', 'plots', 'rows', 'payments'], token);
    // }
    // loadTableData();
  }, []);

  return (
    <>
      <PaymentsManagementExample
        columns={columns.filter((prop) => prop.show)}
        defaultRows={fixNullValues(mappedData)}
        // searchText={fixNullValues(filteredData)}
        onRowSelect={(row) => onClickRow(row, () => {}, navigate)}
        currentPage={currentPage}
        rowsPerPage={rowsPerPage}
        onPageChange={onPageChange}
        onRowsPerPageChange={onRowsPerPageChange}
      />
    </>
  );

  return (
    <>
      <ColumnOrderingGrid rows={mappedData} columns={columns.filter((prop) => prop.show)} searchText={searchText} onRowSelect={(row) => onClickRow(row, () => {}, navigate)} />
      <p>
        Location: <span style={{ fontFamily: "'Courier New', Courier, monospace" }}>/PaymentsHome</span>
      </p>
    </>
  );
};

export default PaymentsHome;
